export const MAX_JOB_PREFERENCES_FREE_TEXT_LENGTH = 2000;
